/**
 * GENERATED by scripts/bundle-i18n.mjs — do not edit by hand.
 * Edit the JSON catalogs under locales/<lng>/ and rerun `npm run build:i18n`.
 *
 * Viewer chrome catalogs assembled into the i18next `resources` shape. Bundled
 * statically (the viewer's chrome is small); the JSON tree is copied to
 * dist/i18n/locales by copy-i18n-to-dist.mjs so imports resolve in prod.
 */

import type { Resource } from "@archlang/i18n";

import en_advisory from "./locales/en/advisory.json";
import en_aspectControls from "./locales/en/aspectControls.json";
import en_boardControls from "./locales/en/boardControls.json";
import en_boardEdit from "./locales/en/boardEdit.json";
import en_breadcrumb from "./locales/en/breadcrumb.json";
import en_changes from "./locales/en/changes.json";
import en_colorLegend from "./locales/en/colorLegend.json";
import en_common from "./locales/en/common.json";
import en_editorLayout from "./locales/en/editorLayout.json";
import en_fileBar from "./locales/en/fileBar.json";
import en_lifecycle from "./locales/en/lifecycle.json";
import en_mobileHeader from "./locales/en/mobileHeader.json";
import en_mobileTabBar from "./locales/en/mobileTabBar.json";
import en_nav from "./locales/en/nav.json";
import en_navbar from "./locales/en/navbar.json";
import en_planeSwitcher from "./locales/en/planeSwitcher.json";
import en_search from "./locales/en/search.json";
import en_sidebar from "./locales/en/sidebar.json";
import en_sourceMenu from "./locales/en/sourceMenu.json";
import en_tabs from "./locales/en/tabs.json";
import en_workbench from "./locales/en/workbench.json";
import ru_advisory from "./locales/ru/advisory.json";
import ru_aspectControls from "./locales/ru/aspectControls.json";
import ru_boardControls from "./locales/ru/boardControls.json";
import ru_boardEdit from "./locales/ru/boardEdit.json";
import ru_breadcrumb from "./locales/ru/breadcrumb.json";
import ru_changes from "./locales/ru/changes.json";
import ru_colorLegend from "./locales/ru/colorLegend.json";
import ru_common from "./locales/ru/common.json";
import ru_editorLayout from "./locales/ru/editorLayout.json";
import ru_fileBar from "./locales/ru/fileBar.json";
import ru_lifecycle from "./locales/ru/lifecycle.json";
import ru_mobileHeader from "./locales/ru/mobileHeader.json";
import ru_mobileTabBar from "./locales/ru/mobileTabBar.json";
import ru_nav from "./locales/ru/nav.json";
import ru_navbar from "./locales/ru/navbar.json";
import ru_planeSwitcher from "./locales/ru/planeSwitcher.json";
import ru_search from "./locales/ru/search.json";
import ru_sidebar from "./locales/ru/sidebar.json";
import ru_sourceMenu from "./locales/ru/sourceMenu.json";
import ru_tabs from "./locales/ru/tabs.json";
import ru_workbench from "./locales/ru/workbench.json";

/** Every viewer namespace, derived from the en/ catalog files. */
export const VIEWER_NAMESPACES = ["advisory", "aspectControls", "boardControls", "boardEdit", "breadcrumb", "changes", "colorLegend", "common", "editorLayout", "fileBar", "lifecycle", "mobileHeader", "mobileTabBar", "nav", "navbar", "planeSwitcher", "search", "sidebar", "sourceMenu", "tabs", "workbench"] as const;
export const VIEWER_DEFAULT_NS = "common";

export const resources = {
  en: { "advisory": en_advisory, "aspectControls": en_aspectControls, "boardControls": en_boardControls, "boardEdit": en_boardEdit, "breadcrumb": en_breadcrumb, "changes": en_changes, "colorLegend": en_colorLegend, "common": en_common, "editorLayout": en_editorLayout, "fileBar": en_fileBar, "lifecycle": en_lifecycle, "mobileHeader": en_mobileHeader, "mobileTabBar": en_mobileTabBar, "nav": en_nav, "navbar": en_navbar, "planeSwitcher": en_planeSwitcher, "search": en_search, "sidebar": en_sidebar, "sourceMenu": en_sourceMenu, "tabs": en_tabs, "workbench": en_workbench },
  ru: { "advisory": ru_advisory, "aspectControls": ru_aspectControls, "boardControls": ru_boardControls, "boardEdit": ru_boardEdit, "breadcrumb": ru_breadcrumb, "changes": ru_changes, "colorLegend": ru_colorLegend, "common": ru_common, "editorLayout": ru_editorLayout, "fileBar": ru_fileBar, "lifecycle": ru_lifecycle, "mobileHeader": ru_mobileHeader, "mobileTabBar": ru_mobileTabBar, "nav": ru_nav, "navbar": ru_navbar, "planeSwitcher": ru_planeSwitcher, "search": ru_search, "sidebar": ru_sidebar, "sourceMenu": ru_sourceMenu, "tabs": ru_tabs, "workbench": ru_workbench },
} satisfies Resource;
